import { render, staticRenderFns } from "./Fisa_pdf.vue?vue&type=template&id=005333f3&"
import script from "./Fisa_pdf.vue?vue&type=script&lang=js&"
export * from "./Fisa_pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports